import React, { useRef, useEffect, useState } from "react";
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from "components/reactStrapTable";
import useAxios from "hooks/useAxios";
import useContextService from 'hooks/useContextService';

// let tableDataBackup =[]
const NotificationHistory = (props) => {
  const { notificationId, setShow, show } = props
   const {
        states: { history},
        setStates,
    } = useContextService();
  const [data, setData] = useState([])
  const API = useAxios();
  const { Search } = history;
    const [state, updateState] = useState({
      filters: Search,
    });
  const [sort, setSort] = useState(false)
  const [totalItem, setTotalItem] = useState(0);
  const [startPage, setStartPage] = useState(null)

  const fetchNotificationHistory = async (search) => {
    try {
      const {data} = await API.post('api/ReportConfig/getNotificationCenterAudits',search,
        { hasDefaultURL: true })

      if (data) {
        setData(data.items)
         setTotalItem(data.totalRecords);
      }
      else{
        setData([])
        setTotalItem(0)
      }
    }
    catch (error) {
    }
  }

    const historyData = async (hasfilter) => {
        if (hasfilter == true) {
            SearchTerms.NotificationCenterId =notificationId;
        }
        const tableRes = document.querySelector('.table-responsive');
        tableRes.scrollLeft = 0;
        Search.encryptedNotificationCenterID = notificationId
        setStartPage(2);
        history.Search.currentPage = 1;
        history.Search.pageSize = 10;
        history.Search.orderBy="createddate";
        history.Search.order="desc"
        setStates('history', history);
        await fetchNotificationHistory(Search);
    };

  useEffect(() => {
    if (show) {
     historyData();
    }
  }, [notificationId])

   const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  const handlePageChange = (filter, haveColFilter) => {
          if (haveColFilter) {
              const filterObj = cloneDeep(Search);
              filterObj.filters = [...filterObj.filters, ...filter.filters];
              filterObj.currentPage = filter.currentPage;
              filterObj.pageSize = filter.pageSize;
              history.Search.currentPage = filter.currentPage;
              history.Search.pageSize = filter.pageSize;
              history.Search = { ...history.Search };
              fetchNotificationHistory(filterObj);
          }
          else {
              if (totalItem > 0)
                 fetchNotificationHistory(filter);
              history.Search = { ...history.Search, ...filter };
          }
          setStates('history', history);
      };

          const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            handlePageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            handlePageChange(filter);
        }
    };

      const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return  handlePageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        handlePageChange(filter);
    };

        const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
           handlePageChange(filter, true);
        } else {
            handlePageChange(filter);
            setSort(true)
        }
    };

  let mainCol = [
    {
      dataField: 'createdBy',
      text: 'Modified By',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
    },
    {
      dataField: 'createdDate',
      text: 'Modified Date',
      sort: true,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: 'fieldName',
      text: 'Acted On',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.fieldName),
    },

    {
      dataField: 'actionType',
      text: 'Action Type',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.actionType),
    },
     {
      dataField: 'modification',
      text: 'Modification',
      sort: false,
      width: 400,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.modification),
    },
  ];

  return (
    <>
      <div
        className='table-card scroll-table position-relative border-0 rounded pt-2'
        // fixed-height={(reportsdata && reportsdata.length > 0)? 'fixed-height' : 'default'}
        fixed-height-table='fixed-height-table'
      >
        <ReactStrapTable
         id='view-table'
           //id='configuration-table'
          height={550}
          width={1200}
          data={data}
          columns={mainCol}
          filters={Search}
         handleSort={handleSort}
        onPageChange={onHandlePageChange}
       onPageSizeChange={onPageSizeChange}
        hasDefaultPagination={true}
        sort={sort}
        setSort={setSort}
        totalRecords={totalItem}
         pageSize={Search.pageSize}
          currentPage={Search.currentPage}
          startPage={startPage}
          setStartPage={setStartPage}
          
        >
        </ReactStrapTable>
      </div>

    </>
  )

}

export default NotificationHistory;